import { IGetSiteSamlLoginInfoResult } from '../types/IGetSiteSamlLoginInfoResult';
import { ILoginParams } from '../types/ILoginParams';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class GetSiteSamlLoginInfoRequest extends Request<ILoginParams, IGetSiteSamlLoginInfoResult> {
  constructor(params: ILoginParams) {
    super('getSiteSamlLoginInfo', params);
  }
}
